import { Link } from "react-router-dom";
import { BRAND, CATEGORIES } from "../data/content";
import { Instagram, Mail } from "lucide-react";
import Logo from "./Logo";
import BrandShimmerText from "./BrandShimmerText";
import NewsletterForm from "./NewsletterForm";
import { INSTAGRAM_URL } from "../lib/commerce";
import { LEGAL } from "../lib/legalConfig";
import { openConsentPreferences } from "../lib/consent";

export default function Footer() {
  return (
    <footer className="bg-warm-alt border-t border-wood/40 mt-32" data-testid="site-footer">
      <div className="page-container pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-5">
            <Logo wordmarkClassName="text-5xl md:text-6xl leading-[0.95]" />
            <p className="mt-6 font-display italic text-2xl md:text-3xl text-stone2-dark max-w-md leading-snug">
              {BRAND.tagline}
            </p>
            <p className="mt-8 text-sm text-stone2-mid leading-relaxed max-w-sm">
              {BRAND.description}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-stone2-mid mb-5">Naviga</p>
            <ul className="space-y-3 text-stone2-dark">
              <li><Link className="link-under" to="/guide">Guide</Link></li>
              <li><Link className="link-under" to="/categorie">Categorie</Link></li>
              <li><Link className="link-under" to="/chi-sono">Chi sono</Link></li>
              <li><Link className="link-under" to="/contatti">Contatti</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-stone2-mid mb-5">Categorie</p>
            <ul className="space-y-3 text-stone2-dark text-sm">
              {CATEGORIES.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <Link className="link-under" to={`/categoria/${c.slug}`}>{c.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-stone2-mid mb-5">Legale</p>
            <ul className="space-y-3 text-stone2-dark text-sm">
              <li><Link className="link-under" to="/privacy">Privacy</Link></li>
              <li><Link className="link-under" to="/cookie">Cookie</Link></li>
              <li><Link className="link-under" to="/termini">Termini</Link></li>
              <li><Link className="link-under" to="/note-legali">Note legali</Link></li>
              <li><Link className="link-under" to="/disclosure">Trasparenza</Link></li>
              <li>
                <button
                  type="button"
                  onClick={() => openConsentPreferences()}
                  className="link-under text-left"
                  data-testid="footer-cookie-prefs"
                >
                  Preferenze cookie
                </button>
              </li>
            </ul>
            <div className="flex gap-4 mt-8 text-stone2-dark">
              {INSTAGRAM_URL ? (
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Nestly su Instagram"
                  className="inline-flex items-center justify-center min-h-11 min-w-11 -m-2 p-2 hover:text-sage-ink transition-colors"
                >
                  <Instagram size={20} strokeWidth={1.4} aria-hidden="true" />
                </a>
              ) : null}
              <a
                href={`mailto:${LEGAL.contactEmail}`}
                aria-label="Email Nestly"
                className="inline-flex items-center justify-center min-h-11 min-w-11 -m-2 p-2 hover:text-sage-ink transition-colors"
              >
                <Mail size={20} strokeWidth={1.4} aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-wood/40 max-w-md">
          <NewsletterForm source="footer" />
        </div>

        <div className="mt-20 pt-8 border-t border-wood/40 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-stone2-mid">
          <p data-testid="footer-disclosure">{BRAND.affiliateDisclosure}</p>
          <p>© {new Date().getFullYear()} Nestly — Tutti i diritti riservati.</p>
        </div>

        <p
          className="mt-8 pt-6 border-t border-wood/30 text-center"
          data-testid="footer-by-dlpm"
        >
          <BrandShimmerText
            className="text-sm text-stone2-mid"
            aria-label="By DLPM"
          >
            By DLPM
          </BrandShimmerText>
        </p>
      </div>
    </footer>
  );
}
